export default __webpack_public_path__ + "static/media/bracket-arrow-end-grey.05642384.svg";